// extracted by mini-css-extract-plugin
export default {"button":"SideBarStyles_button__2LvvM","buttonsContainer":"SideBarStyles_buttonsContainer__wW+Cm"};